const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: '#',
  title: 'AR.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'AR Memon',
  role: 'Web Developer',
  description:
    'I am a professional Full Stack Developer with specialization in MERN Technology, also experience in React Native CLI Mobile APP and PHP.',
  resume: 'https://drive.google.com/file/d/1Fsd2do_7raB7aPNCBesIz46nStSqsAXL/view?usp=sharing',
  social: {
    linkedin: 'https://linkedin.com/in/ar-memon',
    github: 'https://github.com/armemon',
    fiverr: 'https://www.fiverr.com/armemon',
  },
}

const mobileAPPs = [
  {
    name: 'Attendance Android App',
    description:
      `A Full Stack MERN Android App made with React Native, NodeJS, Express and MongoDB.\n\n This app boasts features such as secure login authentication, a user-friendly drawer navigation interface, member management, attendance tracking, and various other functionalities, all seamlessly integrated with a robust backend.`,
    stack: ['React Native', 'Redux','MongoDB',"NodeJs"],
    image:["https://raw.githubusercontent.com/armemon/mywebsite/main/MobileApp1a.jpg", "https://raw.githubusercontent.com/armemon/mywebsite/main/MobileApp1b.jpg","https://raw.githubusercontent.com/armemon/mywebsite/main/MobileApp1c.jpg","https://raw.githubusercontent.com/armemon/mywebsite/main/MobileApp1d.jpg","https://raw.githubusercontent.com/armemon/mywebsite/main/MobileApp1e.jpg","https://raw.githubusercontent.com/armemon/mywebsite/main/MobileApp1f.jpg" ],
    // sourceCode: 'https://github.com/armemon/MyFitnesspal',
    downloadAPP: 'https://drive.google.com/file/d/1XUx4_a34K7PnUwQiJLonU1JFONYEHmEc/view?usp=sharing',
    sourceCode: "https://github.com/armemon/Attendance_React_Native/tree/master",
    live:"https://appetize.io/embed/uk7jouhii4rjd22pvleoxaldbq"
  },
]
const projects = [
  {
    name: 'MyFitnessPal',
    description:
      'A fitness app of BMI and Calories calculator with proper Log In & Sign Up authorization.',
    stack: ['React JS', 'Firebase', "Log In Authentication"],
    image:["https://raw.githubusercontent.com/armemon/mywebsite/main/project1a.JPG", "https://raw.githubusercontent.com/armemon/mywebsite/main/project1b.JPG","https://raw.githubusercontent.com/armemon/mywebsite/main/project1c.JPG" ],
    sourceCode: 'https://github.com/armemon/MyFitnesspal',
    livePreview: 'https://armemon.github.io/MyFitnesspal/',
  },
  {
    name: 'Race App Simulator',
    description:
      'A Race app simulator that simulates a race, data is taken from firebase and it shows the position of all runners at that time of race and leadership board is also present.',
    stack: ['Javascript', 'Firebase'],
    image:["https://raw.githubusercontent.com/armemon/mywebsite/main/project2a.JPG", "https://raw.githubusercontent.com/armemon/mywebsite/main/project2b.JPG"],
    sourceCode: 'https://github.com/armemon/RaceApp/',
    livePreview: 'https://armemon.github.io/RaceApp/',
  },
  {
    name: 'Live Building Management System',
    description:
      'An IoT project which automate the whole building management from switching the bulb to power monitoring all in one space, we connected Rasberry Pi to Web app by firebase real-time database.',
    stack: ['Javascript', 'Firebase'],
    image:["https://raw.githubusercontent.com/armemon/mywebsite/main/project3a.JPG", "https://raw.githubusercontent.com/armemon/mywebsite/main/project3b.JPG","https://raw.githubusercontent.com/armemon/mywebsite/main/project3c.JPG" ],
    sourceCode: 'https://github.com/armemon/Energy-Management-System',
    livePreview: 'https://armemon.github.io/Energy-Management-System/',
  },
  {
    name: 'Memon Farm Website',
    description:
      'A E-commerce  website of a Farm',
    stack: ["HTML", "CSS", 'Javascript'],
    image:["https://raw.githubusercontent.com/armemon/mywebsite/main/project4a.JPG", "https://raw.githubusercontent.com/armemon/mywebsite/main/project4b.JPG","https://raw.githubusercontent.com/armemon/mywebsite/main/project4c.JPG","https://raw.githubusercontent.com/armemon/mywebsite/main/project4d.JPG",],
    sourceCode: 'https://github.com/armemon/memonfarm',
    livePreview: 'https://armemon.github.io/memonfarm',
  },
  {
    name: 'Saylani Welfare Website',
    description:
      'A imitate of Syalani Welfare Trust Website',
    stack: ["HTML", "CSS", 'Javascript'],
    image:["https://raw.githubusercontent.com/armemon/mywebsite/main/project5a.JPG", "https://raw.githubusercontent.com/armemon/mywebsite/main/project5b.JPG","https://raw.githubusercontent.com/armemon/mywebsite/main/project5c.JPG","https://raw.githubusercontent.com/armemon/mywebsite/main/project5d.JPG","https://raw.githubusercontent.com/armemon/mywebsite/main/project5e.JPG", "https://raw.githubusercontent.com/armemon/mywebsite/main/project5f.JPG",],
    sourceCode: 'https://github.com/armemon/Saylani-Welfare/',
    livePreview: 'https://armemon.github.io/Saylani-Welfare/',
  },
]
const services = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  { name:'Figma to Web', logo:"DevicesIcon"},

  {name:'MongoDB, NodeJs, Express', logo:"DevicesIcon"},
  {name:'React JS and React Native', logo:"DevicesIcon"},
  {name:'Firebase Backend', logo:"DevicesIcon"}
]
const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'JavaScript',
  'TypeScript',
  'React JS',
  'React Naive',
  'Redux',
  'NodeJS', 'Express',
  'MongoDB', 'FireBase',
  'SASS',
  'Material UI',
  'Git',
  // 'CI/CD',
  // 'Jest',
  // 'Enzyme',
]
const reviews = [
  {
    id: 'html',
    title: 'HTML',
    description:
      'I have a strong command of HTML for organizing web pages and generating meaningful content that can be accessed by all users.',
  },
  {
    id: 'css',
    title: 'CSS',
    description:
    'I possess expertise in utilizing CSS to design web pages and craft visually captivating layouts that enhance the overall user experience.',
  },
  {
    id: 'javascript',
    title: 'JavaScript',
    description:
    'I have substantial experience in employing JavaScript to introduce interactivity and functionality into web pages, resulting in dynamic user interfaces.',
  },
  {
    id: 'react',
    title: 'React',
    description:
      'I am well-versed in React, proficient in creating reusable components and managing application state using hooks and context.',
  },
  {
    id: 'java',
    title: 'Java',
    description:
      'I have extensive experience utilizing Java for object-oriented programming (OOP) and implementing data structures.',
  },
  {
    id: 'aws',
    title: 'Amazon Web Services',
    description:
      'I am certified in AWS and proficient in working with EC2 and RDS instances, leveraging the power of cloud computing for scalable and reliable infrastructure.',
  },
  {
    id: 'figma',
    title: 'Figma',
    description:
    'In my Figma skills, I unleash creativity, designing captivating user interfaces and collaborating seamlessly with designers and developers.',
  },
  {
    id: 'git',
    title: 'Git',
    description:
    'I am proficient in Git, managing code changes, collaborating with others, and resolving conflicts effectively.',
  },
  {
    id: 'github',
    title: 'GitHub',
    description:
      'I am skilled in using GitHub for seamless project collaboration, code sharing, and issue tracking. Through GitHub, I efficiently create and manage repositories and effectively present my work to potential employers.',
  },
  {
    id: 'psql',
    title: 'Postgresql',
    description:
      'I have a strong command of PostgreSQL, encompassing a wide range of skills such as database normalization, triggers, front-end connectivity, and data analysis using software like Power BI.',
  },
  {
    id: 'vite',
    title: 'Vite',
    description:
      'I have gained considerable experience working with Vite for approximately six months, leveraging its capabilities to build React websites and seamlessly deploy them on platforms like Netlify.',
  },
  {
    id: 'py',
    title: 'Python',
    description:
      'With 3 years of Python experience, I am adept at coding functions and creating graphic interfaces using Tkinter.',
  },
  {
    id: 'node',
    title: 'Node',
    description:
      'When it comes to building web applications, I prefer using Node as my runtime environment over Yarn. I have expertise in leveraging Node.js to develop powerful and scalable web applications.',
  },
  {
    id: 'neo',
    title: 'Neo4j',
    description:
      'I am knowledgeable in Neo4j, the graph database management system. I have expertise in utilizing GraphOS to build robust recommendation systems, leveraging the strength of graph-based data modeling.',
  },
  {
    id: 'raspi',
    title: 'Raspberry Pi',
    description:
      'I have hands-on experience with Raspberry Pi, where I utilized a virtual Linux machine to execute programs written in assembly language. This allowed me to explore low-level computing and develop efficient code for the Raspberry Pi platform.',
  },
  {
    id: 'eslint',
    title: 'Eslint',
    description:
      'I utilize ESLint to identify and resolve code issues, as well as standardize the structure of my projects. With ESLint, I ensure code quality and consistency throughout my development process.',
  },
];
const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'arahman.ar2820@gmail.com',
}

export { header, about, mobileAPPs, projects, services, reviews, skills, contact }
